// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-g_6","inner":"Footer_inner__3ocJp","nextIcon":"Footer_nextIcon__3_Wek","innerLeft":"Footer_innerLeft__3awt0"};